import axios from 'axios';

type RemoveFraudIndicatorPayload = {
  FulfillmentPlanId: number;
  FraudIndicatorCode: string;
};

/**
 * Dismisses a fraud indicator from a fulfillment plan
 */
export const dismissFraudIndicator = async (fulfillmentPlanId: string, fraudIndicatorCode: string): Promise<void> => {
  const payload: RemoveFraudIndicatorPayload = {
    FulfillmentPlanId: parseInt(fulfillmentPlanId, 10),
    FraudIndicatorCode: fraudIndicatorCode,
  };

  const response = await axios.post('/fraud/indicator/remove', payload);
  return response.data;
};
